<script>
import appboy from '@braze/web-sdk-core'
import { mapGetters } from 'vuex'

// this key is shared with luxola
const BRAZE_LOCAL_STORAGE_KEY = 'appboyInitialized'

export default {
  name: 'BrazeInitializer',

  computed: {
    ...mapGetters({
      brazeConfig: 'globalConfig/brazeConfig',
      userLoggedIn: 'user/loggedIn',
      cardNumber: 'user/cardNumber',
      firstName: 'user/firstName',
      lastName: 'user/lastName',
      dateOfBirth: 'user/dateOfBirth',
      gender: 'user/gender'
    })
  },

  mounted() {
    if (this.userLoggedIn) {
      this.initializeBraze()
      this.updateUserDetails()
      this.startSession()
    } else {
      const initializationDelay = this.hasBrazeInitialized() ? 0 : 30000
      setTimeout(() => {
        this.initializeBraze()
        this.startSession()
      }, initializationDelay)
    }
  },

  methods: {
    hasBrazeInitialized() {
      const brazeInitialized = localStorage.getItem(BRAZE_LOCAL_STORAGE_KEY)
      return brazeInitialized && brazeInitialized.toLowerCase() === 'true'
    },

    initializeBraze() {
      appboy.initialize(this.brazeConfig.appId, {
        enableLogging: this.brazeConfig.enableLogging,
        baseUrl: this.brazeConfig.baseUrl,
        safariWebsitePushId: this.brazeConfig.safariWebPushId,
        serviceWorkerLocation: this.brazeConfig.serviceWorkerLocation
      })

      if (!this.hasBrazeInitialized()) {
        this.setBrazeInitialized()
      }
    },

    setBrazeInitialized() {
      localStorage.setItem(BRAZE_LOCAL_STORAGE_KEY, true)
    },

    startSession() {
      appboy.openSession()
    },

    updateUserDetails() {
      appboy.changeUser(this.cardNumber)
      this.updateDateOfBirth()
      this.updateFirstName()
      this.updateLastName()
      this.updateGender()
    },

    updateDateOfBirth() {
      if (!this.dateOfBirth) {
        return
      }

      appboy.getUser().setDateOfBirth(
        this.dateOfBirth.getFullYear(),
        this.dateOfBirth.getMonth() + 1, // JS month starts at 0
        this.dateOfBirth.getDate()
      )
    },

    updateFirstName() {
      if (!this.firstName) {
        return
      }

      appboy.getUser().setFirstName(this.firstName)
    },

    updateLastName() {
      if (!this.lastName) {
        return
      }

      appboy.getUser().setLastName(this.lastName)
    },

    updateGender() {
      if (!this.gender) {
        return
      }

      // Accepts the first character of gender
      appboy.getUser().setGender(this.gender.charAt(0))
    }
  },

  render() {
    return null
  }
}
</script>
